<template>
  <div>
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-lg-6 logo-wrapper">
              <h1>Friday Co Estate Agents</h1>
              <hr/>
              <p>Your Residential Property Specialists.</p>

              <router-link to="/contact-us/" class="btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row triangle">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
      <div class="yellow-background"></div>
      <!-- <div class="banner-image"></div> -->
    </div>

    <div class="about">
      <div class="container">
        <div class="row">
           <div class="col-lg-12">
              <div class="about-section">
                <div class="about-title">
                    <h2>
                      <strong class="gunsmoke">
                        Welcome to Friday Co Estate Agents
                        <span>- Your Residential Property Specialists</span>
                      </strong>
                    </h2>
                    <hr class="about-underline"/>
                </div>
                <div id="about-inner">
                  <div class="row">
                    <div class="col-md-6">
                      <p>Moving home is an exciting journey, and at Friday Co Estate Agents, we're here to ensure it's as smooth and stress-free as possible-providing all the support you need under one roof.</p>
                      <p>With over 20 years of experience in the mortgage industry and financial advice through Friday Financial, we've built a reputation for professionalism, integrity, and outstanding client care. At Friday Co, we're proud to bring the same high standards and trusted service to every aspect of your property journey.</p>
                      <p>We combine cutting-edge property technology with a warm, friendly, and personal approach. Our team of experienced professionals is dedicated to delivering a first-class service tailored to your individual needs.</p>
                      <p>Much of our business comes through word-of-mouth-from satisfied clients who recommend us to their friends and family. It's a testament to the care, attention, and results we consistently provide.</p>
                      <p>Whether you're buying, selling, or simply seeking honest, expert advice about your next move, we'd love to help. Call us today or visit our office to find out how we can make your next step the right one.</p>

                      <a href="https://www.rightmove.co.uk/estate-agents/agent/Friday-and-Co-Estate-Agents/Lowestoft-291410.html" target="_blank" rel="nofollow" class="btn btn-orange btn-block mb-5">View Our Properties</a>
                    </div>
                    <div class="col-md-6">
                      <img src="~@/assets/images/homepage-house.jpg" alt="house" style="height: auto !important; width: 100%">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>


    <div class="cta">
      <div class="container">
        <div class="row d-flex align-items-center justify-content-between">
            <h2 class="mb-0 d-flex justify-content-center">
              <strong>Get In Touch</strong>
            </h2>
            <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Home',
  components: { VueSlickCarousel},
  data() {
      return {
        settings: {
        "dots": true,
        "autoplay": true,
        "autoplay-speed": 15000,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1
      }
    }
}


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue